<template>
  <div>
    <banner-page title="תווי קנייה ברשת רמי לוי"
                 :background-position="banner.backgroundPosition"
                 :background-color="banner.backgroundColor"
                 :imgSrc="require('@/assets/super-discount/rami/discount.svg')">

      <div class="flex-column full-width full-height padding-horizontal-m">
        <div class="margin-top-l ri-large-bold-body">תווי קניה בשווי 500 ₪</div>
        <div class="ri-large-body"> הנחה של 5%</div>
        <div class="margin-top-l ri-large-bold-body">החנויות בהן התו תקף:</div>
        <img :src="require('@/assets/super-discount/rami/rami-logos.png')"/>

      </div>
    </banner-page>
    <sticky-bottom button-text="אני רוצה תו קנייה בהנחה!" @click="goToPurchase" :disabled="purchaseDisabled">
      <template v-slot:content>
        <div class="ri-large-body">לרכישת תו קנייה בשווי ₪500</div>
        <div class="ri-bold-body margin-top-xxs">
          במחיר של
          <span class="ri-large-headline">475</span>
          <span class="ri-large-bold-body">₪</span>
        </div>
        <div class="ri-label margin-top-xs voucher-limit">{{voucherState}}</div>
      </template>
    </sticky-bottom>
  </div>

</template>

<script>
import BaseUI from '@riseupil/base-ui';

import StickyBottom from '@/pages/responsive-pages/authenticated/navigation-pages/super-discount/StricyBottom.vue';
import router from '@/router';
import * as LayoutConsts from '@riseupil/base-ui/src/utils/layout-consts';
import { mapActions } from 'vuex';
import BillyApi from '@/api/BillyApi';
import Segment from '@/Segment';

export default {
  name: 'RamiLeviDiscountPage',
  components: {
    StickyBottom,
    BannerPage: BaseUI.Pages.BannerPage,

  },
  data() {
    return {
      banner: {
        backgroundPosition: BaseUI.LayoutConsts.BACKGROUND_POSITION.BOTTOM_LEFT,
        backgroundColor: BaseUI.LayoutConsts.COLOR_VARIANT.GREEN,
      },
      voucherStatus: undefined,
    };
  },

  async created() {
    this.setAppHeaderProps({
      backgroundColorVariant: LayoutConsts.COLOR_VARIANT.GREEN,
      logoColor: BaseUI.Colors.riseupWhite,
      textColor: BaseUI.Colors.riseupWhite,
    });
    this.voucherStatus = await BillyApi.voucherStatusForMember('RAMI_LEVI');
    const voucherCount = this.voucherStatus.existingValue === 0 ? 0 : this.voucherStatus.existingValue / 500;
    Segment.trackUserGot('RamiLevi_SuperDiscount_Entered', { voucherCount });
  },
  computed: {
    voucherState() {
      if (!this.voucherStatus) {
        return '';
      }
      if (this.voucherStatus.existingValue === 0) {
        return 'אפשר לרכוש עד 3 תווים בחודש';
      }
      if (this.voucherStatus.existingValue === 500) {
        return 'אפשר לרכוש עוד שני תווים החודש';
      }
      if (this.voucherStatus.existingValue === 1000) {
        return 'אפשר לרכוש עוד תו אחד החודש';
      }
      return 'רכשת 3/3 תווים החודש. אפשר לחזור ולקנות תווים בחודש הבא';
    },
    purchaseDisabled() {
      return !this.voucherStatus || this.voucherStatus.existingValue === this.voucherStatus.limit;
    },
  },
  methods: {
    ...mapActions('appHeader', ['setAppHeaderProps']),

    async goToPurchase() {
      Segment.trackUserInteraction('RamiLevi_SuperDiscount_Next_Clicked');
      await router.push({ name: 'RamiLeviPurchasePage' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@riseupil/base-ui/src/scss/riseup-colors";
.voucher-limit {
  color: $riseup_blue;
}
</style>
